<script lang="ts">
  import { Col} from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import RecentFileOpen from "./RecentFileOpen.svelte";
  import FileHeader from "./FileHeader.svelte";
</script>

<Col xl="9" md="12" class="box-col-9">
    <div class="file-content">
        <Card cardBodyprops="file-manager">
            <div slot="customheader">
                <FileHeader />
            </div>
            <div slot="contentbody">
                <RecentFileOpen />
            </div>
        </Card>
    </div>
</Col>
